import { render, staticRenderFns } from "./SetupCompanyFeatures.vue?vue&type=template&id=f4170592&scoped=true"
import script from "./SetupCompanyFeatures.vue?vue&type=script&lang=js"
export * from "./SetupCompanyFeatures.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyFeatures.vue?vue&type=style&index=0&id=f4170592&prod&lang=scss"
import style1 from "./SetupCompanyFeatures.vue?vue&type=style&index=1&id=f4170592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4170592",
  null
  
)

export default component.exports